import Vuex from 'vuex'

import Metric from '@/models/metric'
import METRIC_KEYS from '@/models/METRIC_KEYS'

import SapDeltaFormatter from '@/components/sap-delta-formatter'

export default {

    props: {
        /**
         * @returns {Metric|VueProp}
         */
        metric: {
            type: Metric,
            required: true,
        },
    },

    mixins: [
        SapDeltaFormatter,
    ],

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {boolean}
             */
            loading: stateStore => stateStore.metrics ? stateStore.metrics.loading : false,
        }),

        /**
         * @returns {string}
         */
        className() {
            return this.metric.name.replace(/ /g, '-').toLowerCase()
        },

        /**
         * @returns {boolean}
         */
        hasWorsened() {
            return this.metric.hasWorsened
        },

        /**
         * @returns {boolean}
         */
        isSapMetric() {
            return this.metric.key === METRIC_KEYS.sapScore
        },

        /**
         * @returns {string}
         */
        percentageSaving() {
            return this.loading || !this.metric.percentageSaving
                ? ' - '
                : this.metric.percentageSaving.display
        },

        /**
         * Gets the SAP change display, if there is one.
         * @returns {?string}
         */
        sapChange() {
            return this.loading || !this.isSapMetric
                ? ' - '
                : this.formatSapChangeText(this.metric.saving.display)
        },

        /**
         * @returns {string}
         */
        sapRating() {
            return this.loading || !this.isSapMetric
                ? '?'
                : this.getEpcRating(this.metric.projected.value)
        },
    },
}
